export default __webpack_public_path__ + "static/media/wed-gray.70a43bdd.png";